/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CouponAdminDto } from '../models/CouponAdminDto';
import type { CouponClientDto } from '../models/CouponClientDto';
import type { GetCouponBranchesAdminResponse } from '../models/GetCouponBranchesAdminResponse';
import type { GetCouponByCodeResponseClient } from '../models/GetCouponByCodeResponseClient';
import type { GetCouponChannelsAdminResponse } from '../models/GetCouponChannelsAdminResponse';
import type { GetCouponGroupsAdminResponse } from '../models/GetCouponGroupsAdminResponse';
import type { GetCouponRegionsAdminResponse } from '../models/GetCouponRegionsAdminResponse';
import type { GetCouponsClientResponse } from '../models/GetCouponsClientResponse';
import type { GetCouponUsersAdminResponse } from '../models/GetCouponUsersAdminResponse';
import type { Pagination1OfCouponAdminListedDto } from '../models/Pagination1OfCouponAdminListedDto';
import type { Pagination1OfCouponRevelationListedAdminDto } from '../models/Pagination1OfCouponRevelationListedAdminDto';
import type { PostCouponAdminRequest } from '../models/PostCouponAdminRequest';
import type { PutCouponAdminRequest } from '../models/PutCouponAdminRequest';
import type { PutCouponBranchesRequestAdmin } from '../models/PutCouponBranchesRequestAdmin';
import type { PutCouponChannelsRequestAdmin } from '../models/PutCouponChannelsRequestAdmin';
import type { PutCouponGroupsRequestAdmin } from '../models/PutCouponGroupsRequestAdmin';
import type { PutCouponRegionsRequestAdmin } from '../models/PutCouponRegionsRequestAdmin';
import type { PutCouponUsersRequestAdmin } from '../models/PutCouponUsersRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CouponsService {
    /**
     * @returns CouponClientDto OK
     * @throws ApiError
     */
    public static getCouponClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<CouponClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/coupons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCouponsClientResponse OK
     * @throws ApiError
     */
    public static getCouponsClient({
        branchId,
        userAddressId,
    }: {
        branchId?: number,
        userAddressId?: number,
    }): CancelablePromise<GetCouponsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/coupons',
            query: {
                'branchId': branchId,
                'userAddressId': userAddressId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCouponByCodeResponseClient OK
     * @throws ApiError
     */
    public static getCouponByCodeClient({
        code,
        branchId,
        userAddressId,
        cardIt,
    }: {
        code: string,
        branchId: number,
        userAddressId?: number,
        cardIt?: string,
    }): CancelablePromise<GetCouponByCodeResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/coupons/by-code',
            query: {
                'code': code,
                'branchId': branchId,
                'userAddressId': userAddressId,
                'cardIt': cardIt,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCoupons`
     * @returns Pagination1OfCouponAdminListedDto OK
     * @throws ApiError
     */
    public static getCouponsAdmin({
        validFrom,
        validTo,
        redeemCode,
        regionId,
        branchId,
        groupId,
        channelId,
        userId,
        searchWord,
        hasOnItemDiscount,
        hasOnDeliveryDiscount,
        page,
        limit,
    }: {
        validFrom?: string,
        validTo?: string,
        redeemCode?: string,
        regionId?: number,
        branchId?: number,
        groupId?: number,
        channelId?: number,
        userId?: string,
        searchWord?: string,
        hasOnItemDiscount?: boolean,
        hasOnDeliveryDiscount?: boolean,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCouponAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons',
            query: {
                'validFrom': validFrom,
                'validTo': validTo,
                'redeemCode': redeemCode,
                'regionId': regionId,
                'branchId': branchId,
                'groupId': groupId,
                'channelId': channelId,
                'userId': userId,
                'searchWord': searchWord,
                'hasOnItemDiscount': hasOnItemDiscount,
                'hasOnDeliveryDiscount': hasOnDeliveryDiscount,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns CouponAdminDto OK
     * @throws ApiError
     */
    public static createCouponAdmin({
        requestBody,
    }: {
        requestBody?: PostCouponAdminRequest,
    }): CancelablePromise<CouponAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/coupons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns CouponAdminDto OK
     * @throws ApiError
     */
    public static getCouponAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CouponAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns CouponAdminDto OK
     * @throws ApiError
     */
    public static updateCouponAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponAdminRequest,
    }): CancelablePromise<CouponAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCoupons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCouponAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/coupons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns Pagination1OfCouponRevelationListedAdminDto OK
     * @throws ApiError
     */
    public static getCouponRevelationsAdmin({
        id,
        reveledFrom,
        reveledTo,
        userId,
        page,
        limit,
    }: {
        id: number,
        reveledFrom?: string,
        reveledTo?: string,
        userId?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCouponRevelationListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/revelations',
            path: {
                'id': id,
            },
            query: {
                'reveledFrom': reveledFrom,
                'reveledTo': reveledTo,
                'userId': userId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns GetCouponChannelsAdminResponse OK
     * @throws ApiError
     */
    public static getChannelsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCouponChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/channels',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns GetCouponChannelsAdminResponse OK
     * @throws ApiError
     */
    public static updateChannelsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponChannelsRequestAdmin,
    }): CancelablePromise<GetCouponChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}/channels',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns GetCouponUsersAdminResponse OK
     * @throws ApiError
     */
    public static getUsersAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCouponUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/users',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns GetCouponUsersAdminResponse OK
     * @throws ApiError
     */
    public static updateUsersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponUsersRequestAdmin,
    }): CancelablePromise<GetCouponUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}/users',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns GetCouponGroupsAdminResponse OK
     * @throws ApiError
     */
    public static getGroupsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCouponGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/groups',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns GetCouponGroupsAdminResponse OK
     * @throws ApiError
     */
    public static putGroupsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponGroupsRequestAdmin,
    }): CancelablePromise<GetCouponGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}/groups',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns GetCouponBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getBranchesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCouponBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/branches',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns CouponAdminDto OK
     * @throws ApiError
     */
    public static updateBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponBranchesRequestAdmin,
    }): CancelablePromise<CouponAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}/branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCouponDetails`
     * @returns GetCouponRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCouponRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/coupons/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCoupons`
     * @returns GetCouponRegionsAdminResponse OK
     * @throws ApiError
     */
    public static updateRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCouponRegionsRequestAdmin,
    }): CancelablePromise<GetCouponRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/coupons/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
